// TODO: Simplify this hook when reportCategoryVisibility flag is removed (keep only category mode)

import type {
  CategoryResult,
  ClientCapabilities,
} from '../components/Reports/types/clientCategory';
import type { MenuSource } from '../components/RMS/rms.services';
import { RMSSubscriptions } from '../components/RMS/utils/rmsSubscriptions';
import { flagService } from '../services/flagService/flagService';
import { useAppSelector } from './useAppSelector';
import { useClientCategory } from './useClientCategory';

type CategoryModeResult = {
  isLoading: boolean;
  mode: 'category';
  categoryResult: CategoryResult;
  capabilities: ClientCapabilities;
  subscriptions: RMSSubscriptions[];
  showRMSSection: boolean;
};

type LegacyModeResult = {
  isLoading: boolean;
  mode: 'legacy';
  menuSource?: MenuSource;
  subscriptions: RMSSubscriptions[];
  showRMSSection: boolean;
};

export type ReportVisibilityResult = CategoryModeResult | LegacyModeResult;

function hasPOSCapability(result: CategoryResult): boolean {
  if (result.status !== 'categorized') {
    return false;
  }
  return result.category === 'POS_ONLY' || result.category === 'BOTH_ONLINE_AND_POS';
}

export function useReportVisibility(appId: string): ReportVisibilityResult {
  const isFlagOn = useAppSelector((state) =>
    flagService.isFlagOn(state, 'reportCategoryVisibility')
  );
  const isCategoryMode = isFlagOn;
  const { isLoading, categoryResult, capabilities, subscriptions, menuSource } =
    useClientCategory(appId);

  if (isCategoryMode) {
    return {
      isLoading,
      mode: 'category',
      categoryResult,
      capabilities,
      subscriptions,
      showRMSSection: hasPOSCapability(categoryResult),
    };
  }

  return {
    isLoading,
    mode: 'legacy',
    menuSource,
    subscriptions,
    showRMSSection: subscriptions.includes(RMSSubscriptions.BASE),
  };
}
